export const getPeopleCollectionLoading = (state) => state.peopleCollection.loading;
export const getPeopleCollectionFilters = (state) => state.peopleCollection.filters;
export const getCreateShow = (state) => state.peopleCollection.createShow;
export const getPeopleCollectionState = (state) => state.peopleCollection;
export const getPeopleCollection = (state) => state.peopleCollection.collectionItem;
export const getPeopleCollectionError = (state) => state.peopleCollection.collectionLoadError;
